import { useRef, useState, useEffect } from 'react';

import { Filter } from 'vindi-ds-components';

import api from '@services/api';

import listData from '../../utils/list_data';

import ransackFormat from '../../utils/ransack_form';

import { quick as schemaQuick, advanced as schemaAdvanced } from './schema.json';

async function listSubscriptions(params) {
  const request = await api.get('/admin/reports/subscriptions', ransackFormat(params));

  const subscriptions = listData(request?.data.subscriptions, params);

  return {
    subscriptions,
    totalCount: request?.data.subscriptions.length,
  };
}

const pagination = {
  enabled: true,
  perPage: 20,
  getCount: async (query) => query?.data?.totalCount,
};

function useFilterSubscriptions() {
  const [filterFields, setFilterFields] = useState(null);

  useEffect(() => {
    api.get('/admin/reports/filters_parameters_by_report', { report: 'subscriptions_report' }).then((response) => {
      setFilterFields(response?.data?.subscriptions_filter?.fields);
    });
  }, []);

  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: 'subscriptions',
      queryFn: listSubscriptions,
    },
    filterOptions: {
      schemaQuick,
      schemaAdvanced,
      pagination,
    },
  });

  const modalDownloadRef = useRef();
  const modalMassEditRef = useRef();

  return {
    listing,
    modalDownloadRef,
    modalMassEditRef,
    filterFields,
  };
}

export default useFilterSubscriptions;
